import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
    UPDATE_AUTH_USER,
    USER_ROLE_SLUG_LOADING,
    USER_ROLE_SLUG_SUCCESS,
    USER_ROLE_SLUG_FAILURE,
} from "../actions/types/AuthTypes";

const initialState = {
    authUser: null ,
    errorMessage: '',
    successMessage: '',
    showLoading: false,
    userRoleSlug: '',
    userRoleSlugLoading: null,
    userRoleSlugError: null,
};

export function AuthReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_CONFIRMED_ACTION:
            return {
                ...state,
                authUser: action.payload.user,
                errorMessage: '',
                successMessage: 'Login Successfully Completed',
                showLoading: false,
            };

        case LOGOUT_ACTION:
            return {
                ...state,
                authUser: null,
                errorMessage: '',
                successMessage: '',
                userRoleSlug: '',
                userRoleSlugLoading: null,
            };

        case LOGIN_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };

        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                showLoading: action.payload,
            };
        case USER_ROLE_SLUG_LOADING:
            return {
                ...state,
                userRoleSlugLoading: true,
                userRoleSlugError: null
            };
        case USER_ROLE_SLUG_SUCCESS:
            return {
                ...state,
                userRoleSlugLoading: false,
                userRoleSlug: action.payload
            };
        case USER_ROLE_SLUG_FAILURE:
            return {
                ...state,
                userRoleSlugLoading: false,
                userRoleSlugError: action.payload
            };
        case UPDATE_AUTH_USER:
            return {
                ...state,
                authUser: { ...state.authUser, ...action.payload },
            };
        default:
            return state;
    }
}
